define([], function dateFormatServiceModule() {
  'use strict';
  var dateFormatService = function($filter) {
    var formatDate = function formatDate(timestamp, format) {
      return $filter('date')(timestamp, format);
    };

    return {
      formatDate: formatDate
    };
  };

  return dateFormatService;
});
